<template>
    <button 
    class="productsfilter__topic" 
    :class="{'productsfilter__topic--active': eventStore.categoryIdsToFilter.includes(id)}"
    :aria-label="eventStore.categoryIdsToFilter.includes(id) ? `Filter für ${label} deaktivieren` : `Filter für ${label} aktivieren`">
        {{ label }} ({{ count }})
    </button>
</template>

<script setup>
import { defineProps } from 'vue';
import { useEventStore } from '../../store/eventStore';

const props = defineProps({
    id: String,
    label: String,
    count: Number
})

const eventStore = useEventStore();
</script>
